import { createFileRoute, retainSearchParams } from '@tanstack/react-router';
import { BucketQuery } from 'common/types/bucketQuery';

export const Route = createFileRoute('/_auth/_home')({
    validateSearch: BucketQuery,
    search: {
        middlewares: [retainSearchParams(BucketQuery.keyof().options)],
    },
});
